import { DialogContentProps } from '@radix-ui/react-dialog';
import { cn } from '../utils';
import {
  ConfirmationDialogContent,
  type ConfirmationDialogContentProps,
} from './ConfirmationDialogContent';
import { Dialog, DialogContent } from './Dialog';

interface ConfirmationDialogProps
  extends Omit<ConfirmationDialogContentProps, 'onCancel' | 'className'> {
  open?: boolean;
  onClose: () => void;
  DialogContentProps?: DialogContentProps;
}

const ConfirmationDialog = ({
  open = false,
  onClose,
  DialogContentProps,
  ...contentProps
}: ConfirmationDialogProps) => (
  <Dialog open={open} onOpenChange={isOpen => !isOpen && onClose()}>
    <DialogContent
      {...DialogContentProps}
      className={cn(
        'flex max-w-[95vw] flex-col items-center justify-center gap-7 rounded-lg bg-white p-7 text-center sm:max-w-181.75 sm:min-w-130',
        DialogContentProps?.className
      )}
    >
      <ConfirmationDialogContent
        {...contentProps}
        onCancel={onClose}
        cancelUsesDialogClose
      />
    </DialogContent>
  </Dialog>
);

export { ConfirmationDialog };
export type { ConfirmationDialogProps };
